import apiFetch from './apiFetch';

let cachedCentroids = null;

async function getCentroids() {
  if (!cachedCentroids) {
    const res = await apiFetch('/assets/rupture_centroids.json');
    cachedCentroids = await res.json();
  }
  return cachedCentroids;
}

function haversineKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const toRad = deg => (deg * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/** Returns all centroid entries for a given magnitude level. */
export async function getCentroidsForMagnitude(magnitude) {
  const centroids = await getCentroids();
  return centroids.filter(c => c.magnitude === magnitude);
}

/**
 * Returns up to topN nearest scenarios for the given magnitude,
 * sorted by Haversine distance from (lat, lon) to rupture centroid.
 * Each result: { id, magnitude, centroid, distanceKm }
 */
export async function queryNearest(lat, lon, magnitude, topN = 3) {
  const centroids = await getCentroids();
  return centroids
    .filter(c => c.magnitude === magnitude)
    .map(c => ({
      ...c,
      distanceKm: Math.round(haversineKm(lat, lon, c.centroid[1], c.centroid[0])),
    }))
    .sort((a, b) => a.distanceKm - b.distanceKm)
    .slice(0, topN);
}
